/**
 * Profile availability calendar — recurring weekly template + one-off overrides.
 * Stored in user settingsJson.availabilityCalendar (self-service via updateMe).
 */

export type AvailabilityKind = 'available' | 'unavailable'

/** Recurring weekly block (e.g. every Tue 9:00–17:00). dayOfWeek*: 0=Sun … 6=Sat. */
export type AvailabilityRecurringBlock = {
  id: string
  kind: AvailabilityKind
  dayOfWeekStart: number
  startHour: number
  startMinute: number
  dayOfWeekEnd: number
  endHour: number
  endMinute: number
  notes?: string
}

/** One-off block for a specific date range (overrides recurring for that window). */
export type AvailabilityCustomBlock = {
  id: string
  kind: AvailabilityKind
  startTime: string
  endTime: string
  notes?: string
}

export type AvailabilityCalendar = {
  recurringBlocks: AvailabilityRecurringBlock[]
  customBlocks: AvailabilityCustomBlock[]
  updatedAt: string
}

export const EMPTY_AVAILABILITY_CALENDAR = (): AvailabilityCalendar => ({
  recurringBlocks: [],
  customBlocks: [],
  updatedAt: new Date().toISOString(),
})
